/** Settings/general is intentionally opt-out: missing values retain current behavior. */
export function isConsistencyReviewEnabled(general) {
  return general?.consistencyReviewEnabled !== false;
}

/** Mirrors the callable's submitter-or-admin authorization before showing the action. */
export function canDownloadMatterRecordPdf({ matter, user, isAdmin }) {
  return Boolean(
    matter?.completionPdf?.storagePath &&
      (isAdmin || (user?.uid && matter.submittedBy === user.uid))
  );
}

/**
 * The label on the submit button.
 *
 * Admin-editable because the button does two different jobs: with the approval workflow on it
 * starts an approval chain, and with it off it just produces the PDF. A firm may well have its
 * own words for either. An empty setting falls back to the built-in label for the CURRENT mode,
 * so turning the workflow on or off keeps a sensible default rather than stranding wording that
 * describes the other mode.
 */
export function submitButtonLabel(general, { workflowEnabled }) {
  const custom = String(general?.submitButtonLabel || '').trim();
  if (custom) return custom;
  return workflowEnabled ? 'Submit for approval' : 'Send / Download PDF';
}

/**
 * Whether the "Shared with" card is offered on a matter.
 *
 * Defaults to ON when unset, so an absent setting behaves exactly as before. Turning it off
 * hides the control; it does NOT revoke access anyone already has, because silently cutting
 * collaborators off a matter they can currently open is a different and much larger decision
 * than tidying a confusing button away.
 */
export function isSharingEnabled(general) {
  return general?.sharingEnabled !== false;
}
